export const TOOLTIP_ANCESTOR = 'tooltip-ancestor';
const CARD = `card card-body my-2 ${TOOLTIP_ANCESTOR}`;
export const PRIMARY_CARD = `${CARD} bg-primary`;
export const SECONDARY_CARD = `${CARD} bg-secondary`;
export const BLACK_CARD = `${CARD} bg-black`;
export const TITLE_CARD = 'title';
export const SCROLL_CARD = `${PRIMARY_CARD} scroll`;
export const VITESSCE_CONTAINER = 'vitessce-container';
//# sourceMappingURL=classNames.js.map